import React from 'react';
import IconBase from './IconBase';

const NotificationsIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M14,20c0,1.1-0.9,2-2,2s-2-0.9-2-2"/>
            <path d="M19.8,17.4L18,14.7V9c0-2.8-1.9-5.2-4.5-5.8C13.3,2.5,12.7,2,12,2s-1.3,0.5-1.5,1.2C7.9,3.8,6,6.2,6,9v5.7l-1.8,2.7c-0.2,0.3-0.2,0.7,0,1C4.3,18.8,4.6,19,5,19h14c0.4,0,0.7-0.2,0.9-0.5S20,17.8,19.8,17.4z"/>
        </IconBase>
    )
}

export default NotificationsIcon;